import React from 'react';
import { Button } from './ui/Button';
export function AntiDietBlock() {
  return <section className="py-24 bg-stone-100 relative overflow-hidden" data-id="element-1">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#e7e5e4_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-2" />

      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-3">
        <h2 className="font-serif text-4xl font-bold text-stone-900 sm:text-5xl mb-6" data-id="element-4">
          It's not about your weight.
          <br data-id="element-5" />
          <span style={{
          color: '#4bc041'
        }} data-id="element-6">
            It's about your habits.
          </span>
        </h2>
        <p className="text-xl text-stone-600 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-7">
          We reject the diet culture that tells you you're not enough. Our
          philosophy is rooted in self-compassion, intuitive eating, and
          evidence-based nutrition science.
        </p>
        <Button size="lg" variant="primary" data-id="element-8">
          See Our Approach
        </Button>
      </div>
    </section>;
}